import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FaArrowLeft,
  FaHeart,
  FaEnvelope,
  FaUser,
  FaWeight,
  FaGraduationCap,
  FaHome,
  FaPhoneAlt,
  FaUsers,
  FaTint,
  FaCheckCircle,
  FaOm,
  FaMapMarkerAlt,
  FaBriefcase,
  FaRupeeSign,
  FaChevronDown
} from "react-icons/fa";

import Header from "../components/Header";

import { getMatrimonyProfileApi } from "../api/MatrimonyActions";

import Rightchat from "../components/Rightchat";
import Appfooter from "../components/Appfooter";
import Popupchat from "../components/Popupchat";
import {
  FaFacebookF,
  FaTwitter,
  FaWhatsapp,
  FaLinkedinIn,
  FaTelegramPlane,
} from "react-icons/fa";
import { FaHandsPraying } from "react-icons/fa6";

const API_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
)
  .replace(/\/uploads\/?$/, "")
  .replace(/\/$/, "");


const Icon = ({ icon, className }: { icon: any; className?: string }) =>
  React.createElement(icon as any, { className });

const getMatrimonyImageUrl = (
  file?: string | null
) => {
  if (!file || !String(file).trim()) {
    return "/assets/images/user.png";
  }

  const value = String(file).trim();

  if (
    value.startsWith("http://") ||
    value.startsWith("https://")
  ) {
    return encodeURI(value);
  }

  if (value.startsWith("/uploads/")) {
    return encodeURI(`${API_URL}${value}`);
  }

  if (value.startsWith("uploads/")) {
    return encodeURI(`${API_URL}/${value}`);
  }

  if (value.startsWith("/")) {
    return encodeURI(`${API_URL}${value}`);
  }

  return encodeURI(
    `${API_URL}/uploads/matrimony/${value}`
  );
};

const MatrimonyViewProfile: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { state } = useLocation();

  const [profile, setProfile] = useState<any>(state?.profile || null);
  const [loading, setLoading] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);

  const profileId = profile?.matrimony_id || id;
const shareUrl =
  `${API_URL}/share/matrimony/${profileId}`;
  const shareRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (state?.profile) {
      return;
    }

    const fetchProfile = async () => {
      if (!id) {
        setProfile(null);
        return;
      }

      try {
        setLoading(true);

        const result =
          await getMatrimonyProfileApi(id);

        if (
          result?.success === false ||
          result?.status === false
        ) {
          setProfile(null);
          return;
        }

        setProfile(
          result?.data ||
          result ||
          null
        );
      } catch (error) {
        console.error(
          "Matrimony profile fetch error:",
          error
        );

        setProfile(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [id, state?.profile]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        shareRef.current &&
        !shareRef.current.contains(event.target as Node)
      ) {
        setShareOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleShare = (type: string) => {
    if (!profile || !profileId) return;

    const profileName = profile?.full_name || "Matrimony Profile";
    const shareText = `Check this matrimony profile: ${profileName}`;

    const encodedUrl = encodeURIComponent(shareUrl);
    const encodedText = encodeURIComponent(shareText);

    const shareLinks: Record<string, string> = {
      whatsapp: `https://wa.me/?text=${encodeURIComponent(
        `${shareText}\n${shareUrl}`
      )}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
      telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    };

    const selectedShareUrl = shareLinks[type];

    if (!selectedShareUrl) {
      console.error("Unsupported share type:", type);
      return;
    }

    const shareWindow = window.open(
      selectedShareUrl,
      "_blank",
      "width=720,height=560,noopener,noreferrer"
    );

    if (shareWindow) {
      shareWindow.opener = null;
    }

    setShareOpen(false);
  };

  const copyShareLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setShareOpen(false);
    } catch (error) {
      console.error("Unable to copy matrimony profile link:", error);

      const textArea = document.createElement("textarea");
      textArea.value = shareUrl;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      document.execCommand("copy");
      document.body.removeChild(textArea);

      setShareOpen(false);
    }
  };

  if (loading) {
    return (
      <>
        <Header />
      
        <Rightchat />
        <div className="main-content right-chat-active matrimony-view-main-page">
          <div className="middle-sidebar-bottom matrimony-view-middle-bottom">
            <div className="middle-sidebar-left matrimony-view-middle-left">
              <div className="card border-0 shadow-xss rounded-4 p-5 text-center">
                <h3>Loading profile...</h3>
              </div>
            </div>
          </div>
        </div>
        <Popupchat />
        <Appfooter />
      </>
    );
  }

  if (!profile) {
    return (
      <>
        <Header />
      
        <Rightchat />
        <div className="main-content right-chat-active matrimony-view-main-page">
          <div className="middle-sidebar-bottom matrimony-view-middle-bottom">
            <div className="middle-sidebar-left matrimony-view-middle-left">
              <div className="card border-0 shadow-xss rounded-4 p-5 text-center">
                <h3>No profile found</h3>
                <button
                  className="btn bg-current text-white mt-3 rounded-pill px-4"
                  onClick={() => navigate(-1)}
                >
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
        <Popupchat />
        <Appfooter />
      </>
    );
  }

  const imageUrl = getMatrimonyImageUrl(
    profile?.profile_photo
  );

  return (
    <>
      <Header />
     
      <Rightchat />

      <style>{`
        .matrimony-view-main-page {
          background: #ffffff !important;
          min-height: 100vh;
          padding-top: 84px;
          padding-left: 300px;
          padding-right: 330px;
          overflow-x: hidden;
          box-sizing: border-box;
        }

        .matrimony-view-middle-bottom {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          box-sizing: border-box;
          background: transparent !important;
        }

        .matrimony-view-middle-left {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          padding: 0 12px;
          margin: 0;
          box-sizing: border-box;
          background: transparent !important;
        }

        .matrimony-view-wrapper {
          width: 100%;
          max-width: 980px;
          margin: 0 auto;
          padding: 0 0 38px;
          box-sizing: border-box;
          min-width: 0;
          overflow: visible;
          background: transparent !important;
        }

        .view-top-actions { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; flex-wrap: wrap; gap: 16px; width: 100%; min-width: 0; }
        .view-top-actions > * { min-width: 0; }
        .back-btn { border: none; background: transparent; display: flex; align-items: center; gap: 10px; color: #0f172a; font-size: 15px; font-weight: 600; }
        .action-btns { display: flex; gap: 14px; flex-wrap: wrap; align-items: center; justify-content: flex-end; max-width: 100%; min-width: 0; }
        .outline-btn, .primary-btn { height: 46px; padding: 0 24px; border-radius: 30px; display: flex; align-items: center; justify-content: center; gap: 10px; font-size: 14px; font-weight: 600; white-space: nowrap; }
        .outline-btn { border: 1px solid #2563eb; background: #fff; color: #2563eb; }
        .primary-btn { border: none; background: linear-gradient(135deg,#2563eb,#1d4ed8); color: #fff; box-shadow: 0 10px 24px rgba(37,99,235,.22); }

        .share-dropdown { position: relative; }
        .share-menu { position: absolute; top: 54px; right: 0; width: 170px; background: #fff; border: 1px solid #dbe7f5; border-radius: 14px; box-shadow: 0 15px 35px rgba(15,23,42,.14); padding: 8px; z-index: 9999; }
        .share-menu button { width: 100%; border: none; background: transparent; text-align: left; padding: 10px 12px; border-radius: 10px; color: #0f172a; font-size: 14px; font-weight: 500; }
        .share-menu button:hover { background: #eff6ff; color: #2563eb; }

        .profile-card, .section-card { background: #fff; border: 1px solid #dbe7f5; box-shadow: 0 8px 28px rgba(15,23,42,.05); }
        .profile-card { border-radius: 26px; padding: 24px; margin-bottom: 22px; background: radial-gradient(circle at top right,rgba(37,99,235,.08),transparent 30%),linear-gradient(135deg,#ffffff,#f8fbff,#ffffff); }
        
        /* Adjusted height scale down to prevent profile image distorting in lean card */
        .profile-image-box { height: 320px; border-radius: 22px; overflow: hidden; position: relative; background: #f3f4f6; width: 100%; }
        .profile-image { width: 100%; height: 100%; object-fit: cover; object-position: top; }
        .online-badge { position: absolute; top: 14px; left: 14px; background: #eff6ff; border: 1px solid #bfdbfe; color: #2563eb; border-radius: 20px; padding: 6px 14px; font-size: 12px; font-weight: 600; }
        .profile-id { position: absolute; bottom: 14px; left: 14px; background: rgba(15,23,42,.78); color: #fff; border-radius: 10px; padding: 7px 12px; font-size: 12px; font-weight: 500; }
        .profile-right { padding: 5px 0; height: 100%; display: flex; flex-direction: column; justify-content: center; }
        .profile-name { display: flex; align-items: center; gap: 10px; font-size: 26px; font-weight: 600; color: #0f172a; margin-bottom: 8px; flex-wrap: wrap; }
        .verified-icon { color: #2563eb; font-size: 18px; }
        .location-text { color: #64748b; font-size: 14px; margin-bottom: 12px; }
        .meta-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 20px; color: #475569; font-size: 14px; font-weight: 400; }

        /* Re-allocated to 2x2 grid structure internally to keep information block clean */
        .info-grid { border-top: 1px solid #dbe7f5; padding-top: 20px; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; margin-bottom: 20px; align-items: center; }
        .info-grid .mini-info { padding: 0; background: transparent; border-radius: 0; height: 100%; }
        .mini-info { display: flex; align-items: center; gap: 10px; min-width: 0; }
        .mini-icon, .detail-icon, .section-icon { background: #eff6ff; color: #2563eb; display: flex; align-items: center; justify-content: center; }
        .mini-icon { width: 38px; height: 38px; min-width: 38px; border-radius: 12px; font-size: 14px; }
        .mini-info-content { min-width: 0; display: flex; flex-direction: column; }
        .mini-value { font-size: 13px; font-weight: 700; color: #0f172a; margin: 0; line-height: 18px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-transform: capitalize; }
        .mini-label { display: block; font-size: 11px; font-weight: 500; color: #64748b; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        .about-box { border: 1px solid #dbe7f5; border-radius: 18px; padding: 16px 18px; background: #fff; color: #475569; font-size: 14px; line-height: 24px; }
        .quote { color: #2563eb; margin-right: 10px; font-size: 18px; }
        .section-card { border-radius: 24px; padding: 24px; margin-bottom: 18px; }
        .section-title { display: flex; align-items: center; gap: 12px; font-size: 19px; font-weight: 600; color: #0f172a; margin-bottom: 24px; }
        .section-icon { width: 36px; height: 36px; min-width: 36px; border-radius: 11px; font-size: 15px; }
        
        /* Converted to 3 columns to match grid visual flow cleanly */
        .religion-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px 12px; width: 100%; }
        .religion-item { padding: 0; border-right: none; min-width: 0; }
        .religion-label, .detail-label { display: block; margin-bottom: 6px; font-size: 12px; font-weight: 400; color: #64748b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .religion-value, .detail-value { font-size: 13px; font-weight: 500; color: #0f172a; line-height: 20px; margin: 0; word-break: break-word; }
        
        .detail-card { border: 1px solid #dbe7f5; border-radius: 16px; padding: 14px; display: flex; align-items: center; gap: 12px; height: 100%; background: #fff; min-height: 72px; }
        .detail-icon { width: 34px; height: 34px; min-width: 34px; border-radius: 10px; font-size: 14px; }

        @media (min-width: 1600px) {
          .matrimony-view-main-page {
            padding-left: 300px;
            padding-right: 340px;
          }

          .matrimony-view-wrapper {
            max-width: 1000px;
          }
        }

        @media (max-width: 1500px) {
          .matrimony-view-main-page {
            padding-left: 300px;
            padding-right: 315px;
          }

          .matrimony-view-wrapper {
            max-width: 940px;
          }
        }

        @media (max-width: 1366px) {
          .matrimony-view-main-page {
            padding-left: 295px;
            padding-right: 300px;
          }

          .matrimony-view-wrapper {
            max-width: 860px;
            margin: 0;
          }

          .outline-btn,
          .primary-btn {
            padding-left: 18px;
            padding-right: 18px;
          }

          .action-btns {
            gap: 10px;
          }
        }

        @media (max-width: 1200px) {
          .matrimony-view-main-page {
            padding-left: 24px;
            padding-right: 18px;
            padding-top: 78px;
          }

          .matrimony-view-middle-left {
            padding: 0;
          }

          .matrimony-view-wrapper {
            max-width: 100%;
            margin: 0;
          }
        }

        @media (max-width: 991px) {
          .matrimony-view-main-page {
            padding-left: 16px;
            padding-right: 16px;
            padding-top: 72px;
          }

          .matrimony-view-wrapper {
            padding-bottom: 20px;
          }

          .profile-card,
          .section-card {
            border-radius: 20px;
          }

          .profile-image-box {
            height: 420px;
          }

          .profile-right {
            padding-top: 4px;
          }

          .religion-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 767px) {
          .matrimony-view-main-page {
            padding-left: 12px;
            padding-right: 12px;
          }

          .matrimony-view-wrapper {
            width: 100%;
            padding-bottom: 18px;
          }

          .view-top-actions {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            margin-bottom: 16px;
          }

          .back-btn {
            align-self: flex-start;
          }

          .action-btns {
            width: 100%;
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;
          }

          .action-btns > *,
          .action-btns button {
            min-width: 0;
            width: 100%;
          }

          .outline-btn,
          .primary-btn {
            height: 44px;
            padding: 0 14px;
          }

          .profile-card {
            padding: 16px;
            border-radius: 18px;
          }

          .profile-image-box {
            height: 360px;
            border-radius: 16px;
          }

          .profile-name {
            font-size: 22px;
            line-height: 30px;
          }

          .meta-row {
            gap: 8px;
            margin-bottom: 16px;
          }

          .info-grid {
            gap: 12px;
          }

          .section-card {
            padding: 18px;
            border-radius: 18px;
          }

          .section-title {
            font-size: 18px;
            margin-bottom: 18px;
          }

          .share-menu.share-social-menu {
            position: fixed;
            left: 12px;
            right: 12px;
            top: auto;
            bottom: 18px;
            width: auto !important;
            max-width: none;
          }
        }

        @media (max-width: 575px) {
          .matrimony-view-main-page {
            padding-left: 12px;
            padding-right: 12px;
            padding-top: 70px;
          }

          .action-btns {
            grid-template-columns: 1fr;
          }

          .profile-image-box {
            height: 320px;
          }

          .info-grid,
          .religion-grid {
            grid-template-columns: 1fr;
          }

          .mini-value,
          .mini-label,
          .religion-label {
            white-space: normal;
          }

          .about-box {
            padding: 14px;
          }

          .detail-card {
            min-height: 68px;
          }
        }

        @media (max-width: 380px) {
          .matrimony-view-main-page {
            padding-left: 8px;
            padding-right: 8px;
          }

          .profile-card,
          .section-card {
            padding: 14px;
          }

          .profile-image-box {
            height: 285px;
          }

          .profile-name {
            font-size: 20px;
          }

          .share-menu.share-social-menu {
            left: 8px;
            right: 8px;
            padding: 14px !important;
          }
        }

        .share-social-menu { width: 320px !important; max-width: calc(100vw - 24px); padding: 18px !important; display: flex !important; flex-direction: row !important; gap: 12px !important; flex-wrap: wrap !important; }
        .share-social-menu .social-icon { width: 42px !important; height: 42px !important; min-width: 42px !important; border-radius: 50% !important; padding: 0 !important; border: none !important; color: #fff !important; display: flex !important; align-items: center !important; justify-content: center !important; font-size: 17px !important; }
        .share-social-menu .fb { background: #1877f2 !important; }
        .share-social-menu .tw { background: #1da1f2 !important; }
        .share-social-menu .wa { background: #25d366 !important; }
        .share-social-menu .in { background: #0077b5 !important; }
        .share-social-menu .tg { background: #229ed9 !important; }
        .share-link-box { width: 100%; margin-top: 10px; background: #0f172a; color: #fff; border-radius: 10px; padding: 12px; display: flex; align-items: center; justify-content: space-between; gap: 8px; }
        .share-link-box span { font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .share-link-box button { width: auto !important; padding: 0 !important; background: transparent !important; color: #60a5fa !important; }
      `}</style>

      <div className="main-content right-chat-active matrimony-view-main-page">
        <div className="middle-sidebar-bottom matrimony-view-middle-bottom">
          <div className="middle-sidebar-left matrimony-view-middle-left">
            <div className="matrimony-view-wrapper">
              <div className="view-top-actions">
                <button className="back-btn" onClick={() => navigate(-1)}>
                  <Icon icon={FaArrowLeft} />
                  Back to Search
                </button>

                <div className="action-btns">
                  <div className="share-dropdown" ref={shareRef}>
                    <button
                      className="outline-btn"
                      type="button"
                      onClick={() => setShareOpen(!shareOpen)}
                    >
                      Share Profile
                      <Icon icon={FaChevronDown} />
                    </button>

                    {shareOpen && (
                      <div className="share-menu share-social-menu">
                        <button
                          onClick={() => handleShare("facebook")}
                          className="social-icon fb"
                        >
                          <Icon icon={FaFacebookF} />
                        </button>
                        <button
                          onClick={() => handleShare("twitter")}
                          className="social-icon tw"
                        >
                          <Icon icon={FaTwitter} />
                        </button>
                        <button
                          onClick={() => handleShare("whatsapp")}
                          className="social-icon wa"
                        >
                          <Icon icon={FaWhatsapp} />
                        </button>
                        <button
                          onClick={() => handleShare("linkedin")}
                          className="social-icon in"
                        >
                          <Icon icon={FaLinkedinIn} />
                        </button>
                        <button
                          onClick={() => handleShare("telegram")}
                          className="social-icon tg"
                        >
                          <Icon icon={FaTelegramPlane} />
                        </button>

                        <div className="share-link-box">
                          <span>{shareUrl}</span>
                          <button
                            type="button"
                            onClick={copyShareLink}
                          >
                            Copy
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  <button
                    className="primary-btn"
                    onClick={() => {
                      if (profile?.phone) {
                        window.open(
                          `https://wa.me/91${profile.phone}?text=Hi ${profile.full_name}, I viewed your matrimony profile.`,
                          "_blank",
                        );
                      }
                    }}
                  >
                    <Icon icon={FaEnvelope} />
                    Contact Now
                  </button>
                </div>
              </div>

              <div className="profile-card">
                <div className="row g-4">
                  <div className="col-xl-4 col-lg-5 col-md-12">
                    <div className="profile-image-box">
                      <img
                        src={imageUrl}
                        alt={profile.full_name}
                        className="profile-image"
                        onError={(e: any) => {
                          e.currentTarget.src = "/assets/images/user.png";
                        }}
                      />

                      <span className="profile-id">
                        ID: {profile.matrimony_id}
                      </span>
                    </div>
                  </div>

                  <div className="col-xl-8 col-lg-7 col-md-12">
                    <div className="profile-right">
                      <h1 className="profile-name">
                        {profile.full_name}
                        <Icon icon={FaCheckCircle} className="verified-icon" />
                      </h1>

                      <p className="location-text">
                        {[profile.city, profile.state]
                          .filter(Boolean)
                          .join(", ")}
                      </p>

                      <div className="meta-row">
                        <span>{profile.age} yrs</span>
                        <span>•</span>
                        <span>{formatText(profile.gender)}</span>
                        <span>•</span>
                        <span>{formatDate(profile.date_of_birth)}</span>
                      </div>

                      <div className="info-grid">
                        <MiniInfo
                          icon={FaHeart}
                          label="Marital Status"
                          value={profile.marital_status}
                        />
                        <MiniInfo
                          icon={FaUser}
                          label="Height"
                          value={
                            profile.height_cm ? `${profile.height_cm} Cm` : "--"
                          }
                        />
                        <MiniInfo
                          icon={FaWeight}
                          label="Weight"
                          value={
                            profile.weight_kg ? `${profile.weight_kg} Kg` : "--"
                          }
                        />
                        <MiniInfo
                          icon={FaTint}
                          label="Blood Group"
                          value={profile.blood_group}
                        />
                      </div>

                      {profile.about_profile && (
                        <div className="about-box">
                          <span className="quote">❝</span>
                          {profile.about_profile}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <Section title="Religious Details" icon={FaHandsPraying}>
                <div className="religion-grid">
                  <ReligionItem label="Religion" value={profile.religion} />
                  <ReligionItem label="Caste" value={profile.caste} />
                  <ReligionItem label="Sub Caste" value={profile.sub_caste} />
                  <ReligionItem label="Bari" value={profile.bari} />
                  <ReligionItem label="Gothra" value={profile.gothra} />
                  <ReligionItem
                    label="Mother Tongue"
                    value={profile.mother_tongue}
                  />
                </div>
              </Section>

              <Section title="Lifestyle & Background" icon={FaGraduationCap}>
                <Detail
                  icon={FaGraduationCap}
                  label="Education"
                  value={profile.education}
                />
                <Detail
                  icon={FaBriefcase}
                  label="Occupation"
                  value={profile.occupation}
                />
                <Detail
                  icon={FaBriefcase}
                  label="Company"
                  value={profile.company_name}
                />
                <Detail
                  icon={FaRupeeSign}
                  label="Annual Income"
                  value={formatMoney(profile.annual_income)}
                />
                <Detail
                  icon={FaMapMarkerAlt}
                  label="Work Location"
                  value={[profile.city, profile.state]
                    .filter(Boolean)
                    .join(", ")}
                />
              </Section>

              <Section title="Family Details" icon={FaUsers}>
                <Detail
                  icon={FaUser}
                  label="Father Name"
                  value={profile.father_name}
                />
                <Detail
                  icon={FaUser}
                  label="Mother Name"
                  value={profile.mother_name}
                />
                <Detail
                  icon={FaHome}
                  label="Family Type"
                  value={profile.family_type}
                />
                <Detail
                  icon={FaUsers}
                  label="Family Status"
                  value={profile.family_status}
                />
                <Detail
                  icon={FaUsers}
                  label="Siblings"
                  value={profile.siblings_details}
                />
              </Section>

              <Section title="Contact Details" icon={FaPhoneAlt}>
                <Detail icon={FaPhoneAlt} label="Phone" value={profile.phone} />
                <Detail
                  icon={FaPhoneAlt}
                  label="WhatsApp"
                  value={profile.whatsapp_number}
                />
                <Detail icon={FaEnvelope} label="Email" value={profile.email} />
                <Detail
                  icon={FaMapMarkerAlt}
                  label="City"
                  value={profile.city}
                />
                <Detail
                  icon={FaMapMarkerAlt}
                  label="District"
                  value={profile.district}
                />
                <Detail
                  icon={FaMapMarkerAlt}
                  label="State"
                  value={profile.state}
                />
                <Detail
                  icon={FaMapMarkerAlt}
                  label="Country"
                  value={profile.country}
                />
                <Detail
                  icon={FaUsers}
                  label="Community"
                  value={profile.client_name}
                />
              </Section>

              {profile.partner_preferences && (
                <Section title="Partner Preferences" icon={FaHeart}>
                  <div className="col-12">
                    <div className="about-box">
                      {profile.partner_preferences}
                    </div>
                  </div>
                </Section>
              )}
            </div>
          </div>
        </div>
      </div>

      <Popupchat />
      <Appfooter />
    </>
  );
};

const MiniInfo = ({ icon, label, value }: any) => (
  <div className="mini-info">
    <div className="mini-icon">
      <Icon icon={icon} />
    </div>
    <div className="mini-info-content">
      <h6 className="mini-value">{formatText(value)}</h6>
      <span className="mini-label">{label}</span>
    </div>
  </div>
);

const Section = ({ title, icon, children }: any) => (
  <div className="section-card">
    <h3 className="section-title">
      <span className="section-icon">
        <Icon icon={icon} />
      </span>
      {title}
    </h3>
    <div className="row g-3">{children}</div>
  </div>
);

const ReligionItem = ({ label, value }: any) => (
  <div className="religion-item">
    <span className="religion-label">{label}</span>
    <h6 className="religion-value">{formatText(value)}</h6>
  </div>
);

const Detail = ({ icon, label, value }: any) => (
  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
    <div className="detail-card">
      <div className="detail-icon">
        <Icon icon={icon} />
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <span className="detail-label">{label}</span>
        <h6 className="detail-value">{formatText(value)}</h6>
      </div>
    </div>
  </div>
);

const formatText = (value: any) => {
  if (!value) return "--";
  return String(value).replaceAll("_", " ");
};

const formatDate = (value: any) => {
  if (!value) return "--";
  return new Date(value).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatMoney = (value: any) => {
  if (!value) return "--";
  return `₹${Number(value).toLocaleString("en-IN")}`;
};

export default MatrimonyViewProfile;
